import React from 'react';
import './style.scss';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/coffee_hero2.jpg';
import imgHeroMobile from './i/mobile/coffee_hero2.jpg';
import coffeeSvg from './i/svg/pret.svg';
import coffeeSvgFr from './i/svg/pret.svg';
//import arrow from '../../../../assets/images/hero-arrow.png';
//import { TranslatableText } from '../../../../providers/LanguageProvider';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/1b.jpg';
import slide2 from './i/2b.jpg';
import slide3 from './i/3b.jpg';
import slide4 from './i/4b.jpg';
//import slide5 from './i/carousel_coffee_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Coffee = (props) => {

    return (

        <>
            <MetaInfo {...props} />
             <div className="blockwrap our-food-pages coffee">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="coffee" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="coffee" />
                    }
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    {props.lang === 'en' ? <img className="img-svg" src={coffeeSvg} alt={"coffee"} /> : <img className="img-svg" src={coffeeSvgFr} alt={"coffee"} />}
                    {props.lang === 'en' && <p>At A&W, we’re proud to serve organic coffee from Pret. Made from sustainably farmed, hand-picked 100% arabica beans, this rich and fragrant coffee tastes as good as the goodness that goes into it.</p>}
                    {props.lang === 'fr' && <p>Chez A&W, nous sommes fiers de servir le café biologique de Pret, préparé à partir de grains 100 % arabica cueillis à la main. Un café riche et savoureux issu de l’agriculture durable qui contribue au bien-être de la planète.</p>}
                    {/*<img src={arrow} className="bounce" alt="arrow" />*/}
                </div>

            </div>

            <SliderWrap {...props} >

                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                        </div>
                    </div>
                
                </div>

                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                        </div>
                    </div>
                </div>

                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                        </div>
                    </div>
                </div>

                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                        </div>
                    </div>
                </div>
            </SliderWrap>


            
            <div className="blockwrap our-food faq-block coffee">
                <Link  className="find-aw"  to={`/${props.lang}/faq/beverages`}>
                    {props.lang !== 'fr' ? 
                        <><span></span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ </span><Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="coffee" {...props} />
            <MobileOrderBanner {...props} />
        </>

    )
}
export default Coffee;